import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { WorldMap } from "@/components/ui/world-map";
import { CircularTestimonials } from "@/components/ui/circular-testimonials";
import AnimatedTextCycle from "@/components/ui/animated-text-cycle";
import ExitIntent from "@/components/ExitIntent";
import iconoBlanco from "../assets/logo-blanco.png";
import SEO from '../components/SEO';
import SectionHeader from '../components/SectionHeader';
import SchemaOrg from '../components/SchemaOrg';
import Floating, { FloatingElement } from "@/components/ui/parallax-floating";
import { cn } from "@/lib/utils";
import videoMaquina from "@/assets/video/maquina3d.mp4";

// Datos para el mapa mundial
const mapDots = [
  {
    start: { lat: 40.4168, lng: -3.7038 }, // Madrid
    end: { lat: 51.5074, lng: -0.1278 }, // Londres
  },
  {
    start: { lat: 40.4168, lng: -3.7038 }, // Madrid
    end: { lat: 48.8566, lng: 2.3522 }, // París
  },
  {
    start: { lat: 40.4168, lng: -3.7038 }, // Madrid
    end: { lat: 41.9028, lng: 12.4964 }, // Roma
  },
  {
    start: { lat: 40.4168, lng: -3.7038 }, // Madrid
    end: { lat: 52.5200, lng: 13.4050 }, // Berlín
  },
  {
    start: { lat: 40.4168, lng: -3.7038 }, // Madrid
    end: { lat: 40.7128, lng: -74.0060 }, // Nueva York
  },
  {
    start: { lat: 40.4168, lng: -3.7038 }, // Madrid
    end: { lat: 19.4326, lng: -99.1332 }, // Ciudad de México
  },
  {
    start: { lat: 40.4168, lng: -3.7038 }, // Madrid
    end: { lat: -34.6037, lng: -58.3816 }, // Buenos Aires
  },
];

const googleReviews = [
  {
    author: {
      name: "Mario Mazza",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "La verdad es que no suelo dejar reseñas, como suele pasar, uno solo se acuerda cuando la experiencia no ha sido buena. Sin embargo, lo bueno también hay que destacarlo. Hace unos meses necesitaba con urgencia una máquina y recordé un email que había recibido a finales de año, donde mencionaban que se dedicaban a maquinaria para el sector alimentario, justo el sector en el que trabajo. Los contacté y, desde que visité sus instalaciones, en solo una semana ya tenía la máquina funcionando. A día de hoy la sigo utilizando sin problemas, y probablemente necesite más maquinaria próximamente. Sin duda, es muy útil contar con este tipo de contactos cuando surgen necesidades imprevistas. Muy recomendables.",
    stars: 5,
  },
  {
    author: {
      name: "Sergio",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "Trato profesional y cercano. Teníamos varias necesidades para nuestra carnicería , nos asesoraron qué tipo de maquinaria cumplía con nuestras expectativas y así fue. Tanto su departamento técnico como el departamento comercial nos guió con gran profesionalidad , sin duda volveremos a contar con sus servicios para futuras compras.",
    stars: 5,
  },
  {
    author: {
      name: "Deona66",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1488161628813-04466f872d24?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "Finalmente tras mucho buscar máquinas de vacío, di con esta empresa. Es cierto que había leído algo sobre ellos a través de diferentes portales de compraventa de maquinaria . Me decidí a ir a sus exposiciones de Madrid y finalmente acabé comprando una Supervac . Tras 1 año y medio, no he tenido problemas con esta máquina . Toda una experiencia positiva haber coincidido con ellos",
    stars: 5,
  },
  {
    author: {
      name: "Luis Javier Quintana",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "He comprado ya en 3 veces ocasiones máquinas con ellos, la primera la compré hace 4 años cuando empeze con el obrador. En la primera máquina tuve algún percance pero las últimas dos la verdad que solo tengo cosas buenas que decir, me ayudaron en la instalación y me explicaron cómo podía hacer mi producto que no es nada común, por eso pongo este comentario en felicitación a su mejora de servicio técnico",
    stars: 5,
  },
  {
    author: {
      name: "ismael07",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "Compré una Termoselladora Ilpra con skin, la máquina tiene unos 10 años pero se la ve bastante acondicionada por dentro. De momento no he tenido ninguna pega con ella y los mecánicos de allí le explicaron bien el funcionamiento a mi encargado.",
    stars: 5,
  },
  {
    author: {
      name: "Olivia Román",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "Ǫuiero expresar mi agradecimiento por la buena atención que recibí al comprar una termoformadora. El personal de ventas fue amable, respondiendo a todas mis consultas y proporcionando recomendaciones útiles. Un servicio al cliente de alta calidad.",
    stars: 5,
  },
  {
    author: {
      name: "Aaron Martinez",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "Cerré la fábrica hace 2 años después de tener las máquinas paradas y la nave ocupada durante más de un año , en octubre del año pasado contante con ellos y les dejé las máquinas en depósito para que me las vendieran. Ya han venido 17 máquinas del lote, Me gustaría felicitarles por lo rápido que lo están gestionando y lo cómodo que ha sido",
    stars: 5,
  },
  {
    author: {
      name: "Cristian FM",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "Compré una termoselladora hace dos meses y funciona a la perfección. Muy contento tanto con el producto como por el servicio y el trato. Les volveré a comprar seguro.",
    stars: 5,
  },
  {
    author: {
      name: "María de los angeles",
      handle: "Reseña de Google",
      avatar:
        "https://images.unsplash.com/photo-1498529381350-89c2e7ccc930?w=150&h=150&fit=crop&crop=face", // Placeholder
    },
    text: "Recientemente compré una loncheadora automática para mi panadería y bastante contento, la verdad. La máquina es fácil de usar, eficiente y ha aumentado nuestra productividad. ¡Una gran inversión!",
    stars: 5,
  },
];

// Transform googleReviews to the format expected by AnimatedTestimonials
const transformedTestimonials = googleReviews.map((review, index) => ({
  id: index + 1,
  name: review.author.name,
  role: "Cliente Verificado", // Adjusted role
  company: "Innotec Food", // Added company context
  content: review.text,
  rating: review.stars,
  avatar: review.author.avatar,
}));

const testimonialsForCircular = googleReviews.map((review) => {
  return {
    quote: review.text,
    name: review.author.name,
    designation: "Cliente Verificado",
    src: videoMaquina,
  };
});

// <-- Añadido: Imágenes para el efecto parallax -->
const parallaxImages = [
  {
    url: "/images/parallax/1.jpg",
    className: "top-[5%] left-[10%] w-32 h-32 md:w-40 md:h-40",
    depth: 0.6,
  },
  {
    url: "/images/parallax/2.jpg",
    className: "top-[15%] left-[75%] w-40 h-40 md:w-48 md:h-48",
    depth: 1.2,
  },
  {
    url: "/images/parallax/3.jpg",
    className: "top-[60%] left-[5%] w-36 h-36 md:w-44 md:h-44",
    depth: 1.8,
  },
  {
    url: "/images/parallax/4.jpg",
    className: "top-[70%] left-[85%] w-28 h-28 md:w-36 md:h-36",
    depth: 0.8,
  },
  {
    url: "/images/parallax/5.jpg",
    className: "top-[80%] left-[40%] w-32 h-32 md:w-40 md:h-40",
    depth: 1.5,
  },
];
// <-- Fin añadido -->

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <SEO
        title="Innotec Food Equipment | Maquinaria Industrial para Alimentación"
        description="Especialistas en maquinaria industrial para el sector alimentario. Soluciones innovadoras para procesamiento, envasado y automatización de alimentos."
        canonicalUrl="/"
      />

      {/* Schema.org markup */}
      <SchemaOrg
        type="organization"
        data={{
          url: "https://www.innotecfood.eu",
          logo: "https://www.innotecfood.eu/images/logo.png",
          name: "Innotec Food Equipment",
          description: "Especialistas en maquinaria industrial para el sector alimentario. Soluciones innovadoras para procesamiento, envasado y automatización de alimentos.",
          address: {
            streetAddress: "Paseo castellana 259 C, Piso 18",
            addressLocality: "Madrid",
            postalCode: "28046",
            addressCountry: "ES"
          },
          contactPoint: {
            telephone: "+34613222510",
            email: "info@innotecfood.com"
          },
          sameAs: [
            "https://www.facebook.com/innotecfood",
            "https://www.instagram.com/innotecfood",
            "https://www.linkedin.com/company/innotecfood"
          ]
        }}
      />

      <SchemaOrg
        type="website"
        data={{
          url: "https://www.innotecfood.eu",
          name: "Innotec Food Equipment",
          description: "Especialistas en maquinaria industrial para el sector alimentario. Soluciones innovadoras para procesamiento, envasado y automatización de alimentos.",
          inLanguage: "es"
        }}
      />

      <ExitIntent />
      {/* Hero Section */}
      <section className="relative min-h-[90vh] md:min-h-screen flex items-center justify-center overflow-hidden">
        {/* Floating Parallax Images */}
        <Floating className="z-0" sensitivity={1.5} easingFactor={0.05}>
          {parallaxImages.map((img) => (
            <FloatingElement
              key={img.url}
              className={cn(img.className, "opacity-20")}
              depth={img.depth}
            >
              <img
                src={img.url}
                alt=""
                className="rounded-lg w-full h-full object-cover shadow-lg"
              />
            </FloatingElement>
          ))}
        </Floating>

        {/* Background video or image */}
        <div className="absolute inset-0 z-0">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          >
            <source src="/videos/hero-background.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
        </div>

        {/* Mapa Mundial como fondo */}
        <div className="absolute inset-0 z-0 opacity-70 w-full h-full">
          <WorldMap dots={mapDots} lineColor="#FCAA0D" />
        </div>

        {/* Icono en la parte superior */}
        <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-10">
          <img src={iconoBlanco} alt="InnoTec Icon" className="h-20 md:h-44" />
        </div>

        <div className="relative h-full flex items-center z-10 pt-20 md:pt-0">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="max-w-4xl mx-auto text-center"
            >
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 md:mb-6 leading-tight">
                Optimiza tu producción alimentaria con maquinaria industrial de alto rendimiento
              </h1>

              <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-8 md:mb-10 leading-relaxed max-w-3xl mx-auto">
                Maquinaria nueva y de ocasión, lista para entregar. Asesoramiento experto, garantía premium y soporte 24/7.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 max-w-lg mx-auto">
                <a href="/new" className="w-full">
                  <Button
                    size="lg"
                    className="w-full bg-[#FCAA0D] hover:bg-[#fdb92e] text-black font-bold text-sm sm:text-base md:text-lg py-3 sm:py-4 md:py-6 transition-all duration-300 ease-out shadow-lg hover:shadow-[#FCAA0D]/40 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
                  >
                    Maquinaria Innotec®
                  </Button>
                </a>
                <a href="/used" className="w-full">
                  <Button
                    size="lg"
                    variant="outline"
                    className="w-full bg-transparent hover:bg-white/10 backdrop-blur-sm border-2 border-white hover:border-[#FCAA0D] text-white hover:text-[#FCAA0D] font-bold text-sm sm:text-base md:text-lg py-3 sm:py-4 md:py-6 transition-all duration-300 ease-out shadow-lg hover:shadow-[#FCAA0D]/20 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]"
                  >
                    Maquinaria de ocasión
                  </Button>
                </a>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Flecha indicadora de scroll */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden sm:block">
          <svg
            className="w-6 h-6 text-white/70"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>
      </section>

      {/* Social Proof Section */}
      <div className="container mx-auto px-4 -mt-16 sm:-mt-20 relative z-20">
        <div className="bg-neutral-900/50 backdrop-blur-md border border-neutral-700 rounded-2xl shadow-xl">
          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-y-8 md:gap-x-8 text-center p-8 md:p-10"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={{
              visible: { transition: { staggerChildren: 0.2 } },
            }}
          >
            {/* Item 1: Industrias */}
            <motion.div
              className="flex flex-col items-center space-y-2"
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
              }}
            >
              <div className="bg-[#FCAA0D]/10 p-3 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#FCAA0D]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-7 0H3m2 0h5M5 6h14M5 9h14m0 3h-5m-4 0H5m14 3h-5m-4 0H5" />
                </svg>
              </div>
              <p className="text-4xl sm:text-5xl font-bold text-white">+100</p>
              <p className="text-base text-gray-300">Industrias confían cada año en Innotec</p>
            </motion.div>

            {/* Item 2: Experiencia */}
            <motion.div
              className="flex flex-col items-center space-y-2"
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
              }}
            >
              <div className="bg-[#FCAA0D]/10 p-3 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#FCAA0D]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <p className="text-4xl sm:text-5xl font-bold text-white">15+</p>
              <p className="text-base text-gray-300">Años de experiencia</p>
            </motion.div>

            {/* Item 3: Envíos */}
            <motion.div
              className="flex flex-col items-center space-y-2"
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
              }}
            >
              <div className="bg-[#FCAA0D]/10 p-3 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-[#FCAA0D]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9V3m0 18a9 9 0 009-9m-9 9a9 9 0 00-9-9" />
                </svg>
              </div>
              <p className="text-4xl sm:text-5xl font-bold text-white">Global</p>
              <p className="text-base text-gray-300">Envíos a todo el mundo</p>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Testimonials Section */}
      <section className="pt-20 sm:pt-24 pb-8 sm:pb-12">
        <div className="container mx-auto px-4">
          <div className="mb-6 sm:mb-10 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2">
              Lo que dicen nuestros clientes
            </h2>
            <p className="text-sm sm:text-base text-gray-300 max-w-2xl mx-auto">
              Descubre por qué las empresas confían en Innotec Food para sus necesidades de maquinaria alimentaria. Opiniones reales de nuestros clientes.
            </p>
          </div>

          <div className="flex items-center justify-center">
            <CircularTestimonials testimonials={testimonialsForCircular} />
          </div>
        </div>
      </section>

      {/* Catalog Section */}
      <section className="py-12 sm:py-16 bg-black border-y border-neutral-800">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
              Explora Nuestros Catálogos
            </h2>
            <p className="text-base sm:text-lg text-gray-300 max-w-3xl mx-auto mb-8 leading-relaxed">
              Descarga nuestros catálogos completos para conocer en detalle toda nuestra gama de maquinaria nueva y de ocasión.
            </p>
            <a href="/catalogos">
              <Button
                size="lg"
                variant="outline"
                className="bg-transparent hover:bg-white/5 backdrop-blur-sm border-2 border-neutral-600 hover:border-[#FCAA0D] text-gray-200 hover:text-[#FCAA0D] font-bold text-base md:text-lg py-3 md:py-4 px-8 transition-all duration-300 ease-out shadow-lg hover:shadow-[#FCAA0D]/10 hover:shadow-lg hover:scale-[1.03] active:scale-[0.97]"
              >
                Ver Catálogos
              </Button>
            </a>
          </motion.div>
        </div>
      </section>

      {/* Feria Video Section */}
      <section className="py-12 sm:py-20 bg-neutral-900">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
              Nuestra Experiencia en la Feria
            </h2>
            <p className="text-base sm:text-lg text-gray-300 max-w-3xl mx-auto mb-10 sm:mb-16 leading-relaxed">
              Revive los mejores momentos de nuestra participación en la última feria del sector. Descubre las novedades que presentamos y el ambiente que se vivió en nuestro stand.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="relative w-full max-w-5xl mx-auto shadow-2xl rounded-lg overflow-hidden border-2 border-neutral-700 hover:border-[#FCAA0D] transition-colors duration-300"
            style={{ paddingBottom: '56.25%' }} // 16:9 Aspect Ratio
          >
            <iframe
              src="https://www.youtube.com/embed/BQC6FLYFBxk?controls=0&modestbranding=1&rel=0&autoplay=0"
              title="Video de la Feria InnoTec"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full"
              loading="lazy"
            ></iframe>
          </motion.div>
        </div>
      </section>

      {/* Botón flotante de contacto */}
      <div className="fixed bottom-6 right-6 z-50 sm:hidden">
        <a
          href="/contacto"
          className="flex items-center justify-center w-14 h-14 rounded-full bg-[#FCAA0D] shadow-lg shadow-[#FCAA0D]/30 text-black"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        </a>
      </div>
    </div>
  );
}
